import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { CustomLeftArrow } from "./CustomLeftArrow";
import { CustomRightArrow } from "./CustomRightArrow";
import { recipe_default_image } from "../../utils/constants";
export const useItemDetailDialog = (isOpen, setDialogContentMode, itemImageUrls, imageBaseUrl, nutritionLabelImage) => {
    const [labelImageCanLoad, setLabelImageCanLoad] = useState(true);
    useEffect(() => {
        if (isOpen) {
            //Preloads label image to prevent height flicker
            setTimeout(() => {
                const newImage = new Image();
                newImage.src = imageBaseUrl ? `${imageBaseUrl}${nutritionLabelImage}` : nutritionLabelImage !== null && nutritionLabelImage !== void 0 ? nutritionLabelImage : "";
                newImage.onerror = (e) => setLabelImageCanLoad(false);
            }, 100);
        }
    }, [isOpen]);
    const imageCarouselSettings = {
        draggable: false,
        autoPlay: true,
        autoplaySpeed: 5000,
        customLeftArrow: _jsx(CustomLeftArrow, {}),
        customRightArrow: _jsx(CustomRightArrow, {}),
        responsive: {
            superLargeDesktop: {
                // the naming can be any, depends on you.
                breakpoint: { max: 4000, min: 3000 },
                items: 1,
            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 1,
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 1,
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1,
            },
        },
    };
    const handleTabChange = (e, newValue) => {
        setDialogContentMode(newValue);
    };
    const handleImageError = (e) => {
        e.target.src = `${imageBaseUrl}${recipe_default_image}`;
    };
    return {
        labelImageCanLoad,
        imageCarouselSettings,
        handleImageError,
        handleTabChange,
    };
};
